import { useState, useEffect } from "react";
import { Pencil } from "lucide-react";
import { useNavigate } from "react-router-dom";
import EditPdf from "./Daynamicpdf";
import { motion } from "framer-motion";
import axios from "axios";

const API_URL = "https://backend.aktcorp.com/pdfs";

const PdfList = () => {
    const [pdfs, setPdfs] = useState([]);
    const [selectedPdf, setSelectedPdf] = useState(null);
    const navigate = useNavigate();
    const [showPage, setShowPage] = useState(false);

    // ✅ Fetch JWT token from localStorage
    const jwtToken = localStorage.getItem("authToken"); // Adjust the key as needed

    useEffect(() => {
        setTimeout(() => {
            setShowPage(true);
        }, 2000);
    }, []);

    // ✅ Fetch PDFs from API (using JWT instead of API key)
    useEffect(() => {
        const fetchPdfs = async () => {
            try {
                const response = await axios.get(API_URL, {
                    headers: { Authorization: `Bearer ${jwtToken}` }
                });

                // Adjust here depending on API response structure
                setPdfs(response.data.data); // Example: { data: [...] }

            } catch (error) {
                console.error("Error fetching PDFs:", error);
            }
        };


        fetchPdfs();
    }, [jwtToken]);

    if (!showPage) {
        return (
            <motion.div
                animate={{ rotate: 360 }}
                transition={{ repeat: Infinity, duration: 1, ease: "linear" }}
                className="w-24 h-24 border-4 border-t-transparent border-blue-600 rounded-full mx-auto mt-32"
            ></motion.div>
        );
    }

    return (
        <div className="p-6 max-w-4xl mx-auto bg-white text-gray-700 rounded-lg mb-7">
            <motion.h2
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className="text-3xl font-bold text-gray-900 bg-clip-text text-center mb-4 text-transparent bg-gradient-to-r from-blue-500 to-purple-500"
            >
                Edit PDF
            </motion.h2>

            <ul className="space-y-3">
                {pdfs.map((pdf) => (
                    <li
                        key={pdf.id}
                        className="flex items-center justify-between bg-gray-700 p-4 rounded-lg shadow-md hover:bg-gray-800 transition"
                    >
                        <div className="flex-1">
                            <h3 className="font-semibold text-lg text-white">{pdf.title}</h3>
                            <p className="text-sm text-white">Category: {pdf.category}</p>
                            <button
                                onClick={() => navigate(`/view-pdfs/${pdf.id}`)}
                                className="text-blue-400 hover:text-blue-500 text-sm mt-1 underline"
                            >
                                View PDF
                            </button>
                        </div>
                        <button
                            onClick={() => setSelectedPdf(pdf)}
                            className="p-2 bg-blue-500 rounded-full text-white hover:bg-blue-600 transition"
                        >
                            <Pencil size={20} />
                        </button>
                    </li>
                ))}
            </ul>

            {selectedPdf && (
                <EditPdf
                    pdf={selectedPdf}
                    onClose={() => setSelectedPdf(null)}
                    jwtToken={jwtToken} // ✅ Pass jwtToken to EditPdf for updates
                />
            )}
        </div>
    );
};

export default PdfList;
